import { Component, Input, ViewChild } from '@angular/core';
import { DashboardOverview, Modules } from '@app/core/Enum';
import { GetDashboardDonationByTypesOverview } from '@app/core/Store';
import { Store } from '@ngxs/store';
import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ChartComponent,
  ApexFill,
  ApexDataLabels,
  ApexLegend,
} from 'ng-apexcharts';
import { Observable } from 'rxjs';

export type donationChartOptionsv1 = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  fill: ApexFill;
  dataLabels: ApexDataLabels;
  legend: ApexLegend;
  tooltip: any;
};
@Component({
  selector: 'app-dashboard-donation-type-v1',
  templateUrl: './dashboard-donation-type-v1.component.html',
  styleUrls: ['./dashboard-donation-type-v1.component.scss'],
})
export class DashboardDonationTypeComponentv1 {
  @ViewChild('chart') chart: ChartComponent;
  public donationChartOptionsv1: Partial<donationChartOptionsv1>;
  @Input()
  triggerHeaderFilter: Observable<any>;

  @Input() getModuleId: number;

  isNoRecord = true;
  isloadData = false;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.triggerHeaderFilter?.subscribe((filterData) => {
      if (this.getModuleId === Modules.Dashboard) {
        this.getDonationByTypesData(filterData);
      }
    });
  }

  setlabel(data): any {
    let label: any[] = [];
    let count = 0;

    data.forEach((element) => {
      label.push(
        element.name + '- ' + element.percentage + '% ' + '£ ' + element.amount
      );
      if (element.amount === 0) {
        count = count + 1;
      }
    });

    this.isNoRecord = count === data.length ? true : false;
    return label;
  }

  getDonationByTypesData(filterData: any): void {
    this.store
      .dispatch(new GetDashboardDonationByTypesOverview(filterData))
      .subscribe((res) => {
        this.isloadData = true;
        let overViewData = res.dashboard.dashboardDonationByTypesOverview;
        let labels;

        this.isNoRecord = overViewData.data.length === 0;

        if (overViewData.data.length > 0) {
          labels = this.setlabel(overViewData.data);
        }

        this.donationChartOptionsv1 = {
          series: overViewData.series,
          chart: {
            height: 250,
            type: 'pie',
          },
          fill: {
            colors: ['#7B76D3', '#F4C64D'],
          },
          legend: {
            show: true,
            position: 'right',
            horizontalAlign: 'right',
            offsetX: -40,
            offsetY: 30,
            width: 200,
            fontSize: '13px',
            fontFamily: 'Source Sans Pro, sans-serif',
            markers: {
              fillColors: ['#7B76D3', '#F4C64D'],
              offsetY: 3,
              offsetX: -5,
            },
            itemMargin: {
              vertical: 2,
            },
          },
          tooltip: {
            theme: 'light',
            fillSeriesColor: false,
            style: {
              fontFamily: '"Source Sans Pro", sans-serif',
              fontSize: '14px',
            },
            marker: {
              show: false,
            },
            fixed: {
              position: 'topLeft',
            },
            y: {
              formatter: function (val) {
                return '';
              },
              title: {
                formatter: function (seriesName) {
                  return seriesName;
                },
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          labels: labels,
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: 'bottom',
                },
              },
            },
          ],
        };
      });
  }
}
